import React from 'react';
import { motion } from 'framer-motion';

import { AppWrap } from '../../wrapper';
import { images } from '../../constants';
import './Header.scss';

const scaleVariants = {
  whileInView: {
    scale: [0, 1],
    opacity: [0, 1],
    transition: {
      duration: 1,
      ease: 'easeInOut',
    },
  },
};

const Header = () => (
  <div className="app__header app__flex">
    <motion.div
      whileInView={{ x: [-100, 0], opacity: [0, 1] }}
      transition={{ duration: 0.5 }}
      className="app__header-info"
    >
      <div className="app__header-badge">
        <div className="badge-cmp app__flex">
          <span>👋</span>
          <div style={{ marginLeft: 20 }}>
            <p className="p-text">Hello, I am</p>
            <h1 className="head-text">Daipayan</h1>
          </div>
        </div>

        <div className="tag-cmp">
          <div className="tag-header">
            <p className="p-text">Quick Facts</p>
            <div className="status-dot"></div>
          </div>
          <div className="app__header-tag">
            <div className="tag-item">
              <span className="icon">🚀</span>
              <div className="text">
                <p className="p-text"><b>Founding Engineer</b></p>
                <p className="p-text">@ Loqol</p>
              </div>
            </div>
            <div className="tag-item">
              <span className="icon">🎓</span>
              <div className="text">
                <p className="p-text"><b>MS in CS</b></p>
                <p className="p-text">@ CSU East Bay</p>
              </div>
            </div>
            <div className="tag-item">
              <span className="icon">🤖</span>
              <div className="text">
                <p className="p-text"><b>Cloud & AI</b></p>
                <p className="p-text">Building Software and AI Agents</p>
              </div>
            </div>
            <div className="tag-item">
              <span className="icon">📍</span>
              <div className="text">
                <p className="p-text"><b>Based in</b></p>
                <p className="p-text">Hayward, California</p>
              </div>
            </div>
          </div>
        </div>

        <a 
          href="https://drive.google.com/file/d/1A2E6if-uJZsHatfnSY-H3_E56P8ALwys/view?usp=sharing" 
          target="_blank" 
          rel="noreferrer"
          className="app__header-resume app__flex"
        >
          Download Resume
        </a>
      </div>
    </motion.div>

    <motion.div
      whileInView={{ opacity: [0, 1] }}
      transition={{ duration: 0.5, delayChildren: 0.5 }}
      className="app__header-img"
    >
      <img src={images.profile} alt="profile_bg" />
      <motion.img
        whileInView={{ scale: [0, 1] }}
        transition={{ duration: 1, ease: 'easeInOut' }}
        src={images.circle}
        alt="profile_circle"
        className="overlay_circle"
      />
    </motion.div>

    <motion.div
      variants={scaleVariants}
      whileInView={scaleVariants.whileInView}
      className="app__header-circles"
    >
      {[images.react, images.node, images.python].map((circle, index) => (
        <div className="circle-cmp app__flex" key={`circle-${index}`}>
          <img src={circle} alt="profile_bg" />
        </div>
      ))}
    </motion.div>
  </div>
);

export default AppWrap(Header, 'home', 'app__primarybg');
